module.exports = __webpack_public_path__ + "static/media/icon_vieux.9f7e4adb.svg";